import { empleadoService } from '@/_services';

export const empleado = {
    namespaced: true,
    state: {
        current: null,
        status: {}
    },
    actions: {
      getInfo({ commit }, empleadoId) {
          commit('getEmpleadoRequest');

          let empleado_storage = empleadoService.loadStoragedEmpleado();
          if(empleado_storage==null){
            empleadoService.getEmpleado(empleadoId)
            .then(
                empleado => commit('getEmpleadoSuccess', empleado),
                error => commit('getEmpleadoFailure', error)
            );
          } else {
            commit('getEmpleadoSuccess', empleado_storage)
          }
      }
    },
    mutations: {
      getEmpleadoRequest(state) {
          state.current = {};
          state.status = { loading: true };
      },
      getEmpleadoSuccess(state, empleado) {
          state.current = empleado;
          state.status = { loaded: true };
      },
      getEmpleadoFailure(state, error) {
          state.current = null;
          state.status = { error }
      }
    }
}